const KEYS = {
    token: "jwt",
    fcmToken: "fcmToken",
    comCd: "comCd",
    memId: "memId",
};

// ── Setter ────────────────────────────────
const setToken = (token) => localStorage.setItem(KEYS.token, token);
const setFcmToken = (fcmToken) => localStorage.setItem(KEYS.fcmToken, fcmToken);
const setMemId = (memId) => localStorage.setItem(KEYS.memId, memId);
const setComCd = (comCd) => localStorage.setItem(KEYS.comCd, comCd);

// ── Getter ────────────────────────────────
const getToken = () => localStorage.getItem(KEYS.token);
const getFcmToken = () => localStorage.getItem(KEYS.fcmToken);
const getMemId = () => localStorage.getItem(KEYS.memId);
const getComCd = () => localStorage.getItem(KEYS.comCd);

// ── 로그인 여부 ───────────────────────────
const isLoggedIn = () => getToken() !== null;

// ── 로컬스토리지 전체 초기화 ──────────────
const clearStorage = () => {
    Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
};

export const AuthService = {
    setToken, setFcmToken, setMemId, setComCd,
    getToken, getFcmToken, getMemId, getComCd,
    isLoggedIn, clearStorage,
};